import React, { Component } from "react";
import Category from "./Category";
import CategoryV2 from "./CategoryV2";
import { connect } from "react-redux";
import ActionButton from "../ActionButton";
import { isStorefrontGridEnabled } from "../Storefront/featureFlags";

class index extends Component {
  render() {
    const language = this.props.language;
    const storeLayout = this.props.store.settings.store_layout;
    const gridV2 = isStorefrontGridEnabled(this.props.settings);
    const categories = this.props.store.categories
      .filter((cat) => !cat.is_child)
      .map((category, indx) =>
        storeLayout == "grid" ? (
          <Category
            key={"Grid_Category " + category.name + category.id}
            image={
              category.photo_medium
                ? category.photo_medium
                : category.photo
                ? category.photo
                : null
            }
            name={language == "english" ? category.name : category.ar_name}
            numberOfProducts={category.products_count}
            slug={category.slug}
            min_order={category.minimum_order_value}
            settings={this.props.settings}
            language={language}
            history={this.props.history}
          />
        ) : (
          <CategoryV2
            image={
              category.photo_medium
                ? category.photo_medium
                : category.photo
                ? category.photo
                : null
            }
            name={language == "english" ? category.name : category.ar_name}
            numberOfProducts={category.products_count}
            min_order={category.minimum_order_value}
            settings={this.props.settings}
            slug={category.slug}
            history={this.props.history}
            language={language}
            description={
              language === "arabic"
                ? category.ar_description?.trim() || ""
                : category.description?.trim() || ""
            }
          />
        )
      );
    return (
      <>
        <div
          className={gridV2 ? "sf-grid-categories" : "row text-center justify-content-between m-0 w-100 ".concat(
            storeLayout == "grid2" ? "px-1" : ""
          )}
          dir={language == "english" ? "ltr" : "rtl"}
          style={gridV2 ? undefined : { transform: "scaleX(0.983)" }}
        >
          {categories}
        </div>
        <div className="free-space-115"></div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    language: state.store.language,
    cart: state.cart,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(index);
